var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reports-table',{attrs:{"tableName":"Reporte simple","isDetailedReport":false,"permission":{
      downloadPermission: _vm.permissions.DOWNLOAD_SIMPLE_REPORT,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }